<!--FEEDBACK-->
<app-feedback></app-feedback>
<!--END FEEDBACK-->
<!--FOOTER-->
<div class="widgets">
  <section class="wrapper">
    <div class="footer-sub-top">
      <div class="logo">
        <a
          class="gen-neutral-link"
          id="logo"
          rel="noopener noreferrer nofollow"
          href="https://www.genesys.com"
          title="Genesys Moments Connected"
          data-height="40"
          data-padding="15"
          target="_blank">
          <img
            class="logo-main footer-logo scale-with-grid svg"
            src="/assets/img/genesys-logo-white.svg"
            data-retina=""
            data-height=""
            alt="Genesys Moments Connected"
            data-no-retina=""
            width="200"
            height="40" />
        </a>
      </div>
      <div class="phone">
        <a class="gen-neutral-link" rel="noopener noreferrer nofollow" href="tel:+1.888.436.3797">
          <span class="promoNumber">+1.888.436.3797</span>
        </a>
      </div>
    </div>

    <!--GENESYS ABOUT-->
    <div class="sub-bottom">
      <aside id="genesys-links" class="genesys-links">
        <div class="footer-three-col">
          <span class="link-bold">
            <a
              class="gen-neutral-link"
              rel="noopener noreferrer nofollow"
              href="https://www.genesys.com/contact-us"
              target="_blank">
              {{ 'FOOTER.NAVIGATION_LINKS.CONTACT' | translate }}
            </a>
          </span>
          <ul>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/customer-experience/customer-success/customer-care"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.SUPPORT' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/select-region"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.SELECT_REGION' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/sitemap.xml"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.SITEMAP' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/blog"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.BLOG' | translate }}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-three-col">
          <span class="link-bold">
            <a
              class="gen-neutral-link"
              rel="noopener noreferrer nofollow"
              href="https://www.genesys.com/solutions"
              target="_blank">
              {{ 'FOOTER.NAVIGATION_LINKS.SOLUTIONS' | translate }}
            </a>
          </span>
          <ul>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/solutions/customer-service"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.CUSTOMER_SERVICE' | translate }}
              </a>
            </li>
            <!--NOTE: Disable until Jan 2023 when new site launches with new url from Marketing-->
            <!-- <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/solutions/marketing"
                target="_blank">
                Marketing
              </a>
            </li> -->
            <!--NOTE: Disable until Jan 2023 when new site launches with new url from Marketing-->
            <!-- <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/solutions/sales"
                target="_blank">
                Sales
              </a>
            </li> -->
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/partners"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.PARTNERS' | translate }}
              </a>
            </li>
          </ul>
        </div>
        <div class="footer-three-col">
          <span class="link-bold">
            <a
              class="gen-neutral-link"
              rel="noopener noreferrer nofollow"
              href="https://www.genesys.com/company"
              target="_blank">
              {{ 'FOOTER.NAVIGATION_LINKS.COMPANY' | translate }}
            </a>
          </span>
          <ul>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/company/newsroom"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.NEWSROOM' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/company/social-responsibility"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.SOCIAL_RESPONSIBILITY' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/company/leadership"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.LEADERSHIP' | translate }}
              </a>
            </li>
            <li>
              <a
                class="gen-neutral-link"
                rel="noopener noreferrer nofollow"
                href="https://www.genesys.com/company/careers"
                target="_blank">
                {{ 'FOOTER.NAVIGATION_LINKS.CAREERS' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </aside>

      <aside id="about-genesys-aside" aria-labelledby="about-genesys" class="genesys-about">
        <div class="footer-three-col">
          <span class="link-bold">
            <a
              id="about-genesys"
              class="gen-neutral-link"
              rel="noopener noreferrer nofollow"
              href="https://www.genesys.com/company"
              target="_blank">
              {{ 'FOOTER.ABOUT.TITLE' | translate }}
            </a>
          </span>
          <p class="about" [innerHTML]="'FOOTER.ABOUT.DESCRIPTION' | translate"></p>
        </div>
      </aside>
    </div>
    <!--END GENESYS ABOUT-->
    <!--GENESYS SOCIAL MEDIA LINKS-->
    <div class="genesys-social">
      <ul id="menu-genesys-social-list-icons" class="menu">
        <li
          id="menu-item-767"
          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-767">
          <a
            class="social-media"
            target="_blank"
            title="Genesys LinkedIn"
            rel="noopener noreferrer nofollow"
            href="http://www.linkedin.com/company/601919?trk=tyah"
            aria-label="Genesys LinkedIn">
            <i class="icon blue linkedin-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
        <li
          id="menu-item-769"
          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-769">
          <a
            class="social-media"
            target="_blank"
            rel="noopener noreferrer nofollow"
            title="Genesys Instagram"
            href="http://www.instagram.com/genesyscx"
            aria-label="Genesys Instagram">
            <i class="icon blue instagram-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
        <li
          id="menu-item-766"
          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-766">
          <a
            class="social-media"
            target="_blank"
            title="Genesys Twitter"
            rel="noopener noreferrer nofollow"
            href="https://twitter.com/Genesys"
            aria-label="Genesys Twitter">
            <i class="icon blue twitter-x-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
        <li
          id="menu-item-768"
          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-768">
          <a
            class="social-media"
            target="_blank"
            rel="noopener noreferrer nofollow"
            title="Genesys Facebook"
            href="http://www.facebook.com/genesys"
            aria-label="Genesys Facebook">
            <i class="icon blue facebook-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
        <li
          id="menu-item-771"
          class="menu-item menu-item-type-custom menu-item-object-custom menu-item-771">
          <a
            class="social-media"
            target="_blank"
            title="Genesys YouTube"
            rel="noopener noreferrer nofollow"
            href="https://www.youtube.com/user/Genesyslab1"
            aria-label="Genesys YouTube">
            <i class="icon blue youtube-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
        <li
          id="menu-item-772"
          class="hide-on-blog menu-item menu-item-type-custom menu-item-object-custom menu-item-772">
          <a
            class="social-media"
            target="_blank"
            title="Genesys Blog"
            rel="noopener noreferrer nofollow"
            href="https://www.genesys.com/blog"
            aria-label="Genesys Blog">
            <i class="icon blue blog-icon x-small" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--END GENESYS SOCIAL MEDIA LINKS-->
    <!--VERSION INFO-->
    <div class="version-info">
      <p>
        <!-- Version: <span id="info_version">{{version}}</span><br> -->
        Commit: <span id="info_commit">{{ commit }}</span>
      </p>
      <p>
        Branch: <span id="info_branch">{{ branch }}</span>
      </p>
      <p>
        Env: <span id="info_env">{{ env }}</span>
      </p>
    </div>
    <!--END VERSION INFO-->
  </section>
  <!--BACK TO TOP-->
  <ng-container *ngIf="showBackToTop">
    <app-back-to-top></app-back-to-top>
  </ng-container>
  <!--END BACK TO TOP-->
  <!--COPYRIGHT & LEGAL LINKS-->
  <footer class="footer">
    <div class="wrapper footer-row">
      <div class="footer-links">
        <a
          class="gen-neutral-link no-wrap margin-left-x-small"
          rel="noopener noreferrer nofollow"
          href="https://www.genesys.com/company/legal/terms-of-use"
          target="_blank">
          {{ 'FOOTER.COPYRIGHT_LINKS.TERMS_OF_USE' | translate }}
        </a>
        &nbsp;|&nbsp;
        <a
          class="gen-neutral-link no-wrap"
          rel="noopener noreferrer nofollow"
          href="https://www.genesys.com/company/legal/privacy-policy"
          target="_blank">
          {{ 'FOOTER.COPYRIGHT_LINKS.PRIVACY_POLICY' | translate }}
        </a>
        &nbsp;|&nbsp;
        <a
          class="gen-neutral-link no-wrap"
          rel="noopener noreferrer nofollow"
          href="https://www.genesys.com/campaign/subscribe-genesys-communications"
          target="_blank">
          {{ 'FOOTER.COPYRIGHT_LINKS.EMAIL_SUBSCRIPTION' | translate }}
        </a>
        &nbsp;|&nbsp;
        <!--ONETRUST THIRD PARTY CONSENT AND COOKIE PREFERENCES LINK-->
        <button id="ot-sdk-btn" class="gen-neutral-link ot-sdk-show-settings">
          {{ 'FOOTER.COPYRIGHT_LINKS.COOKIES_SETTINGS' | translate }}
        </button>
        <!--END ONETRUST THIRD PARTY CONSENT AND COOKIE PREFERENCES LINK-->
      </div>
      <div class="copyright-links">
        <span class="no-wrap"
          >Copyright &copy; {{ currentYear }}&nbsp;Genesys. All rights reserved.</span
        >
      </div>
    </div>
  </footer>
  <!--END COPYRIGHT & LEGAL LINKS-->
</div>
<!--END FOOTER-->

<!--NGX-JIRA ISSUE COLLECTOR-->
<app-submit-bug></app-submit-bug>
<!--END NGX-JIRA ISSUE COLLECTOR-->
